import React from 'react';
import {Stack} from '@mui/material';
import List from 'components/list/List';
import {EventStatusField} from 'components/list/Fields';
import CreateButton from 'components/forms/CreateButton';
import EventForm from 'components/Event/EventForm';
import dayjs from 'dayjs';
import EventsListFilters from './EventsListFilters';
import {EventCategoryField, EventDateRangeField, EventLiveActionField, EventNameField, EventOwnerField} from './EventListFields';
import ActionMenu from 'components/list/actionMenu/ActionMenu';
import ActionMenuItemNav from 'components/list/actionMenu/ActionMenuItemNav';
import ActionMenuItemEdit from 'components/list/actionMenu/ActionMenuItemEdit';
import ActionMenuItemDelete from 'components/list/actionMenu/ActionMenuItemDelete';
import ActionMenuItemLink from 'components/list/actionMenu/ActionMenuItemLink';
import {Delete, Edit, OpenInNew, Replay, Visibility} from '@mui/icons-material';
import CreateEventFromActivityButton from './CreateEventFromActivityButton';

const MyEventsPage = () => {
  const now = dayjs().startOf('minute');
  const defaultValues = {
    startDate: now,
    endDate: now,
    publicDate: now
  };

  return (
    <List
      bulkOptions={false}
      title="Events"
      listFilters={<EventsListFilters />}
      toolbar={
        <Stack direction={{xs: 'column', sm: 'row'}} spacing={1} justifyContent="flex-end" sx={{width: '100%'}}>
          <CreateEventFromActivityButton sx={{width: {xs: '100%', sm: 'auto'}}} />
          <CreateButton label="Create Event" defaultValues={defaultValues} sx={{width: {xs: '100%', sm: 'auto'}}}>
            <EventForm />
          </CreateButton>
        </Stack>
      }
    >
      <EventNameField source="name" label="Event" />
      <EventDateRangeField source="startDate" label="Date" hideOnMobile />
      <EventOwnerField source="users" label="Owner" hideOnMobile />
      <EventCategoryField source="category" label="Type" hideOnMobile />
      <EventStatusField source="status" label="Status" hideOnMobile />
      <EventLiveActionField label="" hideOnMobile />
        <ActionMenu label="" align="right" variant="cell">
        <ActionMenuItemNav label="View" icon={<Visibility fontSize="small" />} to={(record) => `/my_events/${record?.slug}`} />
        <ActionMenuItemEdit confirmContent={<EventForm />} icon={<Edit fontSize="small" />} />
        <ActionMenuItemLink
          label="Open Live Tracking"
          icon={<OpenInNew fontSize="small" />}
          href={(record) => `${import.meta.env.VITE_DOMAIN_EVENTS}${record?.slug}`}
        />
        <ActionMenuItemLink
          label="Open Replay"
          icon={<Replay fontSize="small" />}
          href={(record) => `${import.meta.env.VITE_DOMAIN_REPLAY}${record?.slug}`}
        />
        <ActionMenuItemDelete icon={<Delete fontSize="small" />} confirmContent="Are you sure you want to delete this event?" />
      </ActionMenu>
    </List>
  );
};

export default MyEventsPage;
